import React from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { chatPurposeOptions } from './constant';
import FormLabelWithIcon from './FormLabelWithIcon';

export const ChatPurposePicker = ({
  intl, options, onValueChange,
  field = 'chatPurpose',
  classes = {}, required = true,
  name = 'chat-purpose',
  label = 'chat-purpose'
}) => {
  return (
    <Grid className={classes?.sectionContainer || ''}>
      <FormLabelWithIcon
        iconName="MessageSquare"
        labelText={intl.formatMessage({ id: label })}
        type="purple"
        required={required}
      />
      <FormControl>
        <RadioGroup
          row
          aria-label={label}
          name={name}
          value={options[field] || ''}
          onChange={event => onValueChange(field, event.target.value, options[field])}
        >
          {chatPurposeOptions.map(({ value, labelId }) => (
            <FormControlLabel
              key={value}
              value={value}
              control={<Radio color="primary" className={classes.radioOption} style={{ paddingTop: '2px', paddingBottom: '2px' }} />}
              label={intl.formatMessage({ id: labelId })}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};
